/** @format */

// Obtenir la clé des documents à partir de l'ID du modèle
export const getDocsKeyFromModelId = (modelId) => {
  if (!modelId) return "";
  const parts = modelId.split("-");
  const last = parts[parts.length - 1];
  return last.charAt(0).toUpperCase() + last.slice(1) + "Docs";
};

// Filtrer les documents déjà créés
export const filterNewDocs = (fileNames) => {
  return fileNames.filter((fileName) => fileName !== "doc already created");
};